(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Skipper', Skipper);

    Skipper.$inject = ['$resource'];

    function Skipper ($resource) {
        var resourceUrl =  'api/board/skippers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
